__turbopack_context__.v({
  "ChallengeCard": "ChallengeCard-module__jQn2Qq__ChallengeCard",
  "content": "ChallengeCard-module__jQn2Qq__content",
  "description": "ChallengeCard-module__jQn2Qq__description",
  "footer": "ChallengeCard-module__jQn2Qq__footer",
  "header": "ChallengeCard-module__jQn2Qq__header",
  "image": "ChallengeCard-module__jQn2Qq__image",
  "industries": "ChallengeCard-module__jQn2Qq__industries",
  "location": "ChallengeCard-module__jQn2Qq__location",
  "overlayText": "ChallengeCard-module__jQn2Qq__overlayText",
  "saves": "ChallengeCard-module__jQn2Qq__saves",
  "sdg": "ChallengeCard-module__jQn2Qq__sdg",
  "title": "ChallengeCard-module__jQn2Qq__title",
});
